import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/20/solid';
import {
  AssetbloxLogoSvgIcon,
  AssetsSvgIcon,
  DashboardSvgIcon,
  OwnedAssetsSvgIcon,
  ProjectsSvgIcon,
} from '../common/IconProvider';
import { useTranslation } from 'react-i18next';
const Sidebar = () => {
  const [isSideBar, setSideBar] = useState();
  useEffect(() => {
    const listener = (event) => {
      setSideBar(event.detail);
    };
    window.addEventListener('sideOpen', listener);
    return () => {
      window.removeEventListener('sideOpen', listener);
    };
  }, []);
  const { t } = useTranslation(['sidebar', 'common']);
  return (
    <div className="openClosePanel">
      <div
        className={`p-4 rounded-lg bg-brandGray dark:bg-slate-800 w-32 gap-4 h-[calc(100vh-132px)] sticky top-[116px] sideBar md:z-20 z-30
          ${isSideBar ? 'open' : ''}`}
      >
        <div className="cursor-pointer w-11 h-11 rounded-full flex items-center justify-center bg-black bg-opacity-5 md:hidden absolute top-5 right-5">
          <XMarkIcon
            onClick={() => setSideBar(false)}
            className="h-5 w-5 text-brandBlue "
            aria-hidden="true"
          />
        </div>
        <a href="/dashboard" className="md:hidden block">
          <div className="rounded-md text-centerpx-2 py-3 cursor-pointer mb-4 active-state">
            <AssetbloxLogoSvgIcon />
          </div>
        </a>
        <NavLink to="/dashboard">
          <div className="rounded-md text-center hover:bg-menuHover px-2  py-3 cursor-pointer mb-4 md:block flex items-center group">
            <DashboardSvgIcon />
            <p className="text-xs text-brandBlue dark:text-slate-300 group-hover:dark:text-brandBlue">
              Dashboard
            </p>
          </div>
        </NavLink>
        <NavLink to="/assets">
          <div className="rounded-md text-center hover:bg-menuHover px-2  py-3 cursor-pointer mb-4 md:block flex items-center group">
            <AssetsSvgIcon />
            <p className="text-xs text-brandBlue dark:text-slate-300 group-hover:dark:text-brandBlue">
              {t('assets')}
            </p>
          </div>
        </NavLink>
        <NavLink to="/owned-assets">
          <div className="rounded-md text-center hover:bg-menuHover px-2  py-3 cursor-pointer mb-4 md:block flex items-center group">
            <OwnedAssetsSvgIcon />
            <p className="text-xs text-brandBlue dark:text-slate-300 group-hover:dark:text-brandBlue">
              {t('owned_assets')}
            </p>
          </div>
        </NavLink>

        <NavLink to="/transactions/fiat">
          <div className="rounded-md text-center hover:bg-menuHover px-2  py-3 cursor-pointer mb-4 md:block flex items-center group">
            <ProjectsSvgIcon />
            <p className="text-xs text-brandBlue dark:text-slate-300 group-hover:dark:text-brandBlue">
              {t('transactions')}
            </p>
          </div>
        </NavLink>
      </div>

      <div
        onClick={() => setSideBar(false)}
        className={
          isSideBar
            ? 'fixed left-0 top-0 w-full h-full bg-black bg-opacity-50 z-10 md:hidden'
            : 'fixed left-0 hidden top-0 w-full h-full bg-black bg-opacity-50 z-10 md:hidden'
        }
      ></div>
    </div>
  );
};

export default Sidebar;
